module.exports = __webpack_public_path__ + "img/lamp.a3f6f228.svg";